import { useState, useEffect } from 'react';
import api from '../api/axios';

// Simple in-memory cache so we don't hammer the API
let cachedDays = null;
let cacheTimestamp = 0;
const CACHE_TTL_MS = 5 * 60 * 1000; // 5 minutes

const DAY_NAMES = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
const DAY_SHORT = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

export function useSchoolDays() {
  const [schoolDays, setSchoolDays] = useState(cachedDays || [1, 2, 3, 4, 5]);
  const [loading, setLoading] = useState(!cachedDays);

  useEffect(() => {
    const now = Date.now();
    if (cachedDays && now - cacheTimestamp < CACHE_TTL_MS) {
      setSchoolDays(cachedDays);
      setLoading(false);
      return;
    }
    api.get('/admin-settings/school-days')
      .then(r => {
        const list = r.data?.school_days || [1, 2, 3, 4, 5];
        cachedDays = list;
        cacheTimestamp = Date.now();
        setSchoolDays(list);
      })
      .catch(() => {
        // Fallback — never break the UI if the API fails
        setSchoolDays([1, 2, 3, 4, 5]);
      })
      .finally(() => setLoading(false));
  }, []);

  const isSchoolDay = (date) => {
    if (!date) return false;
    const d = typeof date === 'string' ? new Date(date) : date;
    return schoolDays.includes(d.getDay());
  };

  const getPreviousSchoolDay = (dateStr) => {
    const d = new Date(dateStr);
    for (let i = 0; i < 14; i++) {
      d.setDate(d.getDate() - 1);
      if (schoolDays.includes(d.getDay())) {
        return d.toISOString().split('T')[0];
      }
    }
    return dateStr;
  };

  const getNextSchoolDay = (dateStr) => {
    const d = new Date(dateStr);
    for (let i = 0; i < 14; i++) {
      d.setDate(d.getDate() + 1);
      if (schoolDays.includes(d.getDay())) {
        return d.toISOString().split('T')[0];
      }
    }
    return dateStr;
  };

  return {
    schoolDays,
    isSchoolDay,
    getPreviousSchoolDay,
    getNextSchoolDay,
    dayNames: schoolDays.map(d => DAY_NAMES[d]),
    dayShort: schoolDays.map(d => DAY_SHORT[d]),
    loading,
  };
}